var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(String(_vm.type).toLowerCase() === 'leadfree')?_c('span',[_vm._v("Lead Free")]):_vm._e(),(String(_vm.type).toLowerCase() === 'leadsafe')?_c('span',[_vm._v("Lead Safe")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }